import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "searchUser",
  standalone: false
})
export class SearchUserPipe implements PipeTransform {
  transform(list: any[], searchText: string): any[] {
    if (!list) {
      return [];
    }
    if (!searchText) {
      return list;
    }
    searchText = searchText.toLowerCase();
    return list.filter((item) => {
      return item.Name.toLowerCase().includes(searchText);
    });
  }
}
